jQuery(document).ready(function ($) {
    //Simple tabs
    
    $(".c-simple-tabs__list li").each(function(){
      $(this).click(function(){
  
        localStorage.selectedTab = $(this).index() + 1;
        var tab_id = $(this).attr('data-tab');
        $('.c-simple-tabs__list li').removeClass('current');
        $('.c-simple-tabs__content').removeClass('current');
        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
  
        return false; 
      });
  
    }); 
    if (localStorage.selectedTab) {
      $(".c-simple-tabs__list li:eq(" + (localStorage.selectedTab - 1) + ")").click();
    }
  
  });
  